/**
 * O painel ao clicar no nome da conversa (ordem da dona, 2026-09-29): perfil,
 * arquivos e pessoas. Fase B: fixar e silenciar (só para mim), descrição do
 * grupo, dar e tirar administração e sair do grupo. Apagar a conversa também
 * é só para mim (2026-10-29).
 */
import { useState } from "react";

import useCliqueFora from "../../hooks/useCliqueFora";
import {
  SIGLA_DO_TIPO,
  alterarConversa,
  definirAdministrador,
  definirMinhaConversa,
  removerParticipante,
  tamanhoLegivel,
} from "../../services/chat";
import { Avatar, ICONE, Ic } from "./Icones";

export function PainelDaConversa({
  detalhe, titulo, telaLarga, aberto, aoFechar, request, podeGerenciar, anexos,
  aoMudar, aoRenomear, aoAdicionar, aoVer, aoSair, aoApagar,
}) {
  const [editandoDescricao, setEditandoDescricao] = useState(null);
  const ativos = (detalhe.participantes || []).filter((p) => !p.saiu_em);
  const fotos = anexos.filter((a) => a.tipo === "imagem" || a.tipo === "video").length;
  const ehGrupo = detalhe.tipo === "grupo";
  // Em tela estreita o painel cobre a conversa: tocar fora fecha. O nome da
  // conversa alterna o painel, e os modais abertos daqui não o fecham.
  const fora = useCliqueFora(aoFechar, {
    ativo: aberto && !telaLarga, ignorar: ".pchat-cab-nome, .pchat-modal-fundo, .pchat-visualizador",
  });

  const minha = (corpo) => definirMinhaConversa(request, detalhe.id, corpo).then(aoMudar).catch(() => undefined);
  const salvarDescricao = () => {
    const descricao = editandoDescricao;
    setEditandoDescricao(null);
    alterarConversa(request, detalhe.id, { descricao }).then(aoMudar).catch(() => undefined);
  };

  return (
    <aside className="pchat-painel" aria-label="Perfil, arquivos e pessoas" {...fora} style={telaLarga ? { display: "flex" } : { display: "flex", position: "fixed", right: 0, top: 0, bottom: 0, zIndex: 1100, boxShadow: "var(--shadow-4, 0 10px 40px rgba(0,0,0,.2))" }}>
      {aberto && <button type="button" className="pchat-btn" style={{ alignSelf: "flex-end" }} aria-label="Fechar" onClick={aoFechar}><Ic d={ICONE.x} size={18} /></button>}
      <div className="cabecalho">
        <Avatar nome={detalhe.nome} bot={detalhe.tipo === "geral"} foto={detalhe.foto_url} />
        <h3>{titulo}</h3>
        <small style={{ color: "var(--ink-4)" }}>{detalhe.tipo === "lote" ? "Conversa do lote" : detalhe.tipo === "geral" ? "Canal geral" : ehGrupo ? "Grupo" : "Direta"}{detalhe.arquivada_em ? " · arquivada" : ""}</small>
        {ehGrupo && editandoDescricao === null && (detalhe.descricao || podeGerenciar) && (
          <p className="pchat-descricao">
            {detalhe.descricao || <span style={{ color: "var(--ink-4)" }}>Sem descrição.</span>}
            {podeGerenciar && <button type="button" className="pchat-link" onClick={() => setEditandoDescricao(detalhe.descricao || "")}>editar</button>}
          </p>
        )}
        {editandoDescricao !== null && (
          <div style={{ display: "grid", gap: 6, width: "100%" }}>
            <textarea className="pchat-busca" rows={3} maxLength={500} value={editandoDescricao} onChange={(e) => setEditandoDescricao(e.target.value)} aria-label="Descrição do grupo" autoFocus />
            <div className="pchat-modal-acoes">
              <button type="button" className="pchat-btn texto" onClick={() => setEditandoDescricao(null)}>Cancelar</button>
              <button type="button" className="pchat-btn enviar texto" onClick={salvarDescricao}>Salvar</button>
            </div>
          </div>
        )}
        <div className="pchat-botoes-linha">
          <button type="button" className="pchat-btn texto" aria-pressed={!!detalhe.fixada} onClick={() => minha({ fixada: !detalhe.fixada })}>
            <Ic d={ICONE.pino} size={14} /> {detalhe.fixada ? "Soltar do topo" : "Fixar no topo"}
          </button>
          <button type="button" className="pchat-btn texto" aria-pressed={!!detalhe.silenciada} onClick={() => minha({ silenciada: !detalhe.silenciada })}>
            <Ic d={ICONE.sino} size={14} /> {detalhe.silenciada ? "Tirar do silencioso" : "Silenciar"}
          </button>
        </div>
        {podeGerenciar && (
          <div className="pchat-botoes-linha">
            <button type="button" className="pchat-btn texto" onClick={aoRenomear}><Ic d={ICONE.edit} size={14} /> Renomear</button>
            {!detalhe.arquivada_em && <button type="button" className="pchat-btn texto" onClick={() => alterarConversa(request, detalhe.id, { arquivar: true }).then(aoMudar).catch(() => undefined)}>Arquivar</button>}
          </div>
        )}
      </div>
      <div className="pchat-totais">
        <div><small>Fotos e vídeos</small><b>{fotos}</b></div>
        <div><small>Arquivos</small><b>{anexos.length - fotos}</b></div>
      </div>
      {anexos.length > 0 && (
        <div style={{ display: "grid", gap: 2 }}>
          <h3>Arquivos recentes</h3>
          {anexos.slice(-12).reverse().map((a) => (
            <button key={a.id} type="button" className="pchat-arquivo" style={{ minWidth: 0 }} onClick={() => aoVer(anexos, anexos.indexOf(a))}>
              <span className={`tipo ${a.tipo}`}>{SIGLA_DO_TIPO[a.tipo]}</span>
              <span className="meta"><b>{a.nome}</b><span>{tamanhoLegivel(a.tamanho)}</span></span>
            </button>
          ))}
        </div>
      )}
      <div>
        <h3 style={{ display: "flex", justifyContent: "space-between" }}>Pessoas <small style={{ color: "var(--ink-4)" }}>{ativos.length}</small></h3>
        <div className="pchat-membros">
          {ativos.map((p) => (
            <div key={p.id} className="pchat-membro">
              <Avatar nome={p.nome} pequeno foto={p.foto_url} />
              <span className="nome">{p.online && <span className="pchat-online" title="online agora" />}{p.nome}{p.tipo === "operador" && <small style={{ color: "var(--ink-4)" }}> · operador</small>}</span>
              {p.administrador && <small style={{ color: "var(--ink-4)" }}>admin</small>}
              {podeGerenciar && ehGrupo && p.id !== detalhe.eu?.id && (
                <button
                  type="button" className="pchat-chip" style={{ height: 24 }}
                  title={p.administrador ? "Tirar a administração" : "Tornar administrador"}
                  onClick={() => definirAdministrador(request, detalhe.id, p.id, !p.administrador).then(aoMudar).catch(() => undefined)}
                >{p.administrador ? "− admin" : "+ admin"}</button>
              )}
              {podeGerenciar && p.id !== detalhe.eu?.id && (
                <button type="button" className="pchat-chip" style={{ height: 24 }} aria-label={`Tirar ${p.nome}`} onClick={() => removerParticipante(request, detalhe.id, p.id).then(aoMudar).catch(() => undefined)}><Ic d={ICONE.x} size={12} /></button>
              )}
            </div>
          ))}
        </div>
        {podeGerenciar && !detalhe.arquivada_em && <button type="button" className="pchat-btn texto" style={{ marginTop: 8 }} onClick={aoAdicionar}><Ic d={ICONE.plus} size={14} /> Adicionar pessoa</button>}
        <div className="pchat-botoes-linha" style={{ marginTop: 8 }}>
          {ehGrupo && <button type="button" className="pchat-btn texto perigo" onClick={aoSair}>Sair do grupo</button>}
          <button type="button" className="pchat-btn texto perigo" onClick={aoApagar}><Ic d={ICONE.trash} size={14} /> Apagar conversa</button>
        </div>
      </div>
    </aside>
  );
}
